import * as React from "react";
import { View, Image } from "react-native";
import Svg, { Defs, ClipPath, Use, Path, LinearGradient, Stop, G, Circle } from "react-native-svg";
function Logo(props) {
    return (
        <Image
            source={require('./logo.png')}
            style={{  width: 150, height: 50 }}
        />
    );
}

export default Logo;
